import Vue from 'vue';
import Router from 'vue-router';
import Home from '@p/page/home';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path:'/',
      // name: 'home',
      component:Home,
      children:[
       {
         path: '/',
         name:'page',
         component: () => import('@p/page/home/components/page.vue'),
         children:[
           {
            path: '/home',
            name:'homePage',
            component: () => import('@p/page/home/components/home-page.vue'),
           },
           {
            path: '/home/exam',
            name:'homeExam',
            component: () => import('@p/page/home/components/home-exam.vue'),
           },
         ]
       },
       {
        path: '/lessons',
        name:'lessons',
        component: () => import('@p/page/lessons'),
      },
      {
        path: '/lessonsMore',
        name:'lessonsMore',
        component: () => import('@p/page/lessons/components/lessonsMore'),
      },
      {
        path: '/hotCourseMore',
        name:'hotCourseMore',
        component: () => import('@p/page/lessons/components/hotCourseMore'),
      },
      {
        path: '/lessonsAll',
        name:'lessonsAll',
        component: () => import('@p/page/lessons/components/lessonsAll'),
      },
      {
        path: '/personal',
        name:'personal',
        component: () => import('@p/page/personal'),
      },
      {
        path: '/home/about',
        name:'about',
        component: () => import('@p/page/about'),
      },
      {
        path: '/home/message',
        name:'message',
        component: () => import('@p/page/message'),
      },
      {
        path: '/home/message/message-new',
        name:'newMessage',
        component: () => import('@p/page/message/components/message-new'),
      },
      {
        path: '/home/lessons/study',
        name:'study',
        component: () => import('@p/page/study'),
      },
      {
        path: '/home/lessons/exercises',
        name:'exercises',
        component: () => import('@p/page/exercises'),
      },
      {
        path: '/exam/list',
        name:'examList',
        component: () => import('@p/page/exam/list'),
      },
      {
        path: '/exam/result-list',
        name:'resultList',
        component: () => import('@p/page/exam/result-list'),
      },
      {
        path: '/exam/result',
        name:'examResult',
        component: () => import('@p/page/exam/exam-result'),
      },
      {
        path: '/exam/questions',
        name:'examQuestions',
        component: () => import('@p/page/exam/exam-questions'),
      },
      {
        path: '/search/list',
        name:'searchList',
        component: () => import('@p/page/search'),
      },
      {
        path: '/myCourse',
        name:'myCourse',
        component: () => import('@p/page/myCourse'),
      }
    ]
   },
   {
     path: '/login',
     name: 'login',
     component: () => import('@p/page/login'),
   },
   {
     path: '*',
     name:'404',
     component: () => import('@p/page/error/404.vue'),
   }
  ],
})